<template>
  <div>
    <div id="processPie1"></div>
    <div id="processPie2"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: "process",
  data() {
    return {
      options: {},
      total: 0,
      ProcessPieChartsDom: null,
      colorList: [
        {
          c1: "#00FFB4",
        },
        {
          c1: "#EA3E3E", //高
        },
        {
          c1: "#FF9000", //正常
        },
        {
          c1: "#e8f383", //危险
        },
        {
          c1: "#287CE8", //危险
        },
        {
          c1: "#6f3eea", //高
        },
        {
          c1: "#63ea3e", //高
        },
        {
          c1: "#ef0be4", //高
        },
        {
          c1: "#6f3eea", //高
        },
        {
          c1: "#63ea3e", //高
        },
        {
          c1: "#ef0be4", //高
        },
      ],
      show: true
    }
  },
  mounted() {
    this.getType1Data()
    this.getType2Data()
  },
  destroyed() {
    this.ProcessPieChartsDom.dispose();
  },
  methods: {
    initProcessPie1Charts() {
      let ProcessPie1ChartsDom = document.getElementById('processPie1')
      this.ProcessPie1ChartsDom = echarts.init(ProcessPie1ChartsDom)
      this.ProcessPie1ChartsDom.setOption(this.options)
      setTimeout(() => {
        window.addEventListener("resize", () => {
          this.ProcessPie1ChartsDom.resize();
        });
      });
    },
    initProcessPie2Charts() {
      let ProcessPie2ChartsDom = document.getElementById('processPie2')
      this.ProcessPie2ChartsDom = echarts.init(ProcessPie2ChartsDom)
      this.ProcessPie2ChartsDom.setOption(this.options)
      setTimeout(() => {
        window.addEventListener("resize", () => {
          this.ProcessPie2ChartsDom.resize();
        });
      });
    },
    nowSize(val, initWidth = 1920) {
      let nowClientWidth = document.documentElement.clientWidth;
      return val * (nowClientWidth / initWidth);
    },
    getType1Data() {
      let colorList = this.colorList
      let data = []
      // 1信息接报 2 监控
      this.$http.get(`/api/getEventNumberByType?channel=1`).then(res => {
        if (res) {
          let datas = res.data.map((item, index) => {
            return {
              value: item.number,
              name: item.name.toString().length > 4 ? item.name.toString().substring(0, 4) + '...' : item.name,
              c: colorList[index].c1,
            }
          })

          for (let i in datas) {
            if (datas[i].name === '总计') {
              this.total = datas[i].value
            } else {
              data.push(datas[i])
            }
          }
          this.options = {
            title: {},
            graphic: {
              type: 'text',
              left: 'center',
              //left: '37%',
              top: 'center',
              style: {
                text: this.total + '\n' + '总计',
                // String(this.circularGraph.sum.number).replace(/(\d)(?=(?:\d{6})+$)/g, '$1.'),
                textAlign: 'center',
                fill: '#fff',
                width: 30,
                height: 30,
                fontSize: '.7rem'
              }
            },
            series: [
              {
                emphasis: {
                  scale: false,
                },
                labelLayout: function (params) {
                  const isLeft = params.labelRect.x < document.getElementById('processPie1').clientWidth / 2;
                  const points = params.labelLinePoints;
                  // Update the end point.
                  points[2][0] = isLeft
                    ? params.labelRect.x
                    : params.labelRect.x + params.labelRect.width;
                  return {
                    labelLinePoints: points
                  };
                },
                label: {
                  // position: 'outer',
                  alignTo: 'edge',
                  edgeDistance: '5%',
                  lineHeight: 14,
                  fontSize: this.nowSize(10),
                  formatter: [
                    '{d}%',
                    '{b}'
                  ].join('\n'),// {b}：数据名；{c}：数据值；{d}：百分比
                },
                labelLine: {
                  length: 8,
                  length2: 40
                },
                radius: ['58%', '60%'],
                // selectedOffset: 0,
                avoidLabelOverlap: false,
                name: 'processPie',
                type: 'pie',
                minAngle: 60,//最小角度
                data: data.map((item, index) => {
                  item.label = {
                    color: item.c
                  };
                  item.itemStyle = {
                    color: item.c,
                  }
                  return item;
                }),
                itemStyle: {},
              },
              {
                label: {
                  show: false
                },
                emphasis: {
                  scale: false,
                },
                radius: ['40%', '55%'],
                // selectedOffset: 0,
                avoidLabelOverlap: false,
                name: 'processPie',
                type: 'pie',
                minAngle: 60,//最小角度
                data: data.map((item, index) => {
                  item.label = {
                    color: item.c
                  };
                  return item;
                }),
                itemStyle: {},
              },
              {
                label: {
                  show: false
                },
                radius: ['36%', '38%'],
                emphasis: {
                  scale: false,
                },
                avoidLabelOverlap: false,
                name: 'processPie',
                type: 'pie',
                minAngle: 60,//最小角度
                data: data.map((item, index) => {
                  item.label = {
                    color: item.c
                  };
                  return item;
                }),
                itemStyle: {},
              },
            ]
          }
          this.$nextTick(() => {
            this.initProcessPie1Charts()
          })
        }
      })
    },
    getType2Data() {
      let colorList = this.colorList
      let data = []
      // 1信息接报 2 监控
      this.$http.get(`/api/getEventNumberByType?channel=2`).then(res => {
        if (res) {
          let datas = res.data.map((item, index) => {
            return {
              value: item.number,
              name: item.name.toString().length > 4 ? item.name.toString().substring(0, 4) + '...' : item.name,
              c: colorList[index].c1,
            }
          })

          for (let i in datas) {
            if (datas[i].name === '总计') {
              this.total = datas[i].value
            } else {
              data.push(datas[i])
            }
          }
          this.options = {
            title: {},
            graphic: {
              type: 'text',
              left: 'center',
              //left: '37%',
              top: 'center',
              style: {
                text: this.total + '\n' + '总计',
                // String(this.circularGraph.sum.number).replace(/(\d)(?=(?:\d{6})+$)/g, '$1.'),
                textAlign: 'center',
                fill: '#fff',
                width: 30,
                height: 30,
                fontSize: '.7rem'
              }
            },
            series: [
              {
                emphasis: {
                  scale: false,
                },
                labelLayout: function (params) {
                  const isLeft = params.labelRect.x < document.getElementById('processPie1').clientWidth / 2;
                  const points = params.labelLinePoints;
                  // Update the end point.
                  points[2][0] = isLeft
                    ? params.labelRect.x
                    : params.labelRect.x + params.labelRect.width;
                  return {
                    labelLinePoints: points
                  };
                },
                label: {
                  // position: 'outer',
                  alignTo: 'edge',
                  edgeDistance: '5%',
                  lineHeight: 14,
                  fontSize: this.nowSize(10),
                  formatter: [
                    '{d}%',
                    '{b}'
                  ].join('\n'),// {b}：数据名；{c}：数据值；{d}：百分比
                },
                labelLine: {
                  length: 8,
                  length2: 40
                },
                radius: ['58%', '60%'],
                // selectedOffset: 0,
                avoidLabelOverlap: false,
                name: 'processPie',
                type: 'pie',
                minAngle: 60,//最小角度
                data: data.map((item, index) => {
                  item.label = {
                    color: item.c
                  };
                  item.itemStyle = {
                    color: item.c,
                  }
                  return item;
                }),
                itemStyle: {},
              },
              {
                label: {
                  show: false
                },
                emphasis: {
                  scale: false,
                },
                radius: ['40%', '55%'],
                // selectedOffset: 0,
                avoidLabelOverlap: false,
                name: 'processPie',
                type: 'pie',
                minAngle: 60,//最小角度
                data: data.map((item, index) => {
                  item.label = {
                    color: item.c
                  };
                  return item;
                }),
                itemStyle: {},
              },
              {
                label: {
                  show: false
                },
                radius: ['36%', '38%'],
                emphasis: {
                  scale: false,
                },
                avoidLabelOverlap: false,
                name: 'processPie',
                type: 'pie',
                minAngle: 60,//最小角度
                data: data.map((item, index) => {
                  item.label = {
                    color: item.c
                  };
                  return item;
                }),
                itemStyle: {},
              },
            ]
          }
          this.$nextTick(() => {
            this.initProcessPie2Charts()
          })
        }
      })
    },
  }
}
</script>

<style scoped lang="less">
#processPie1 {
  width: 50%;
  height: 13vh;
  float: left;
}

#processPie2 {
  width: 50%;
  height: 13vh;
  float: left;
}
</style>
